import { IconButton, IconName } from '@optimus-web/core';
import { DataTestId } from '@mews-commander/enums';
import { useEditCentralPaymentPolicyDialogForm } from '../forms';

interface Props {
    paymentPolicyId: string;
}
export const EditPaymentPolicyButton = ({ paymentPolicyId }: Props) => {
    const [renderDialog, toggleDialog] = useEditCentralPaymentPolicyDialogForm({
        paymentPolicyId,
    });

    return (
        <>
            <IconButton
                data-test-id={DataTestId.EditPaymentPolicy}
                icon={IconName.Edit}
                onClick={toggleDialog}
                size="small"
                type="submit"
            />
            {renderDialog()}
        </>
    );
};
